function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function completionPromptKey(prompt) {
  return prompt?.completionCardState ? `${prompt.completionCardState}:${prompt.name}` : prompt?.name;
}

function stageCompletionContextBinding(contextBindings, state, name, binding) {
  const current = isPlainObject(contextBindings) ? contextBindings : {};
  return { ...current, [state]: { ...current[state] ?? {}, [name]: binding } };
}

function pruneStateBindingsToRequired(contextBindings, state, requiredNames) {
  const current = isPlainObject(contextBindings) ? contextBindings : {};
  const stateBindings = isPlainObject(current[state]) ? current[state] : {};
  const keep = new Set(requiredNames);
  const kept = {};
  const discarded = [];
  Object.entries(stateBindings).forEach(([name, binding]) => {
    if (keep.has(name)) {
      kept[name] = binding;
      return;
    }
    discarded.push(name);
  });
  return { contextBindings: { ...current, [state]: kept }, discarded };
}

function pickedStateBindings(selections, contextBindings) {
  const current = isPlainObject(contextBindings) ? contextBindings : {};
  const picked = {};
  Object.entries(selections ?? {}).forEach(([state, cardId]) => {
    if (Number(cardId) > 0) {
      picked[state] = isPlainObject(current[state]) ? { ...current[state] } : {};
    }
  });
  return picked;
}

module.exports = {
  completionPromptKey,
  stageCompletionContextBinding,
  pruneStateBindingsToRequired,
  pickedStateBindings,
};
